import { render, staticRenderFns } from "./refundDepositFee.vue?vue&type=template&id=2bd4c010&scoped=true"
import script from "./refundDepositFee.vue?vue&type=script&lang=js"
export * from "./refundDepositFee.vue?vue&type=script&lang=js"
import style0 from "./refundDepositFee.vue?vue&type=style&index=0&id=2bd4c010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4c010",
  null
  
)

export default component.exports